/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Shengyi Liu
 * @date  2018/4/24 10:22
 * @des  entry通用操作封装
 */
import mixins from './mixins'
import {
  Message, Loading, MessageBox, Notification
} from 'element-ui'
import {setTitle} from '@/base/util/compatible'

const Constant = require('@/base/constants')

export function init (Vue, callback) {

  // register global mixins.
  Vue.mixin(mixins)

  // rigister component
  rigisterComponent(Vue)

  // rigister function
  rigisterFunction(Vue)

  //i18nTitle
  i18nTitleDefault()
}

function rigisterComponent (Vue) {

}

function i18nTitleDefault () {
  setTimeout(() => {
    setTitle('')
  }, 0)
}

function rigisterFunction (Vue) {
  Vue.prototype.$log = function (msg, ...optionalParams) {
    if (Constant.DEBUG) {
      if (optionalParams && optionalParams.length > 0) {
        console.log(msg, ...optionalParams)
      } else {
        console.log(msg)
      }
      // this.$info(msg)
    }
  }

  Vue.prototype.$info = (msg) => {
    Message({
      message: msg,
      type: 'success'
    })
  }
  Vue.prototype.$warn = (msg) => {
    Message({
      message: msg,
      type: 'warning'
    })
  }
  Vue.prototype.$error = (msg) => {
    Message({
      message: msg,
      type: 'error'
    })
  }
  Vue.use(Loading.directive)
  Vue.prototype.$loading = Loading.service
  Vue.prototype.$msgbox = MessageBox
  Vue.prototype.$alert = MessageBox.alert
  Vue.prototype.$confirm = MessageBox.confirm
  Vue.prototype.$prompt = MessageBox.prompt
  Vue.prototype.$notify = Notification
  Vue.prototype.$message = Message

}



// WEBPACK FOOTER //
// ./src/base/init.js